import React, { useState, useEffect } from 'react'
import SecuritySetting from '../components/SecuritySetting'
import { securitySettingServiceConfig } from './shared/config'
import injectWidget from './shared/injectWidget'

function SecuritySettingBuild({
  configureTrack,
  services,
  i18n,
  ...rest
}) {
  const [securityInitData, setSecurityInitData] = useState({
    initComplete: false,
    phoneInfo: {},
    emailInfo: {},
    locale: 'en_US',
    nextTimePhone: '',
    nextTimeEmail: '',
    stateChecker: '',
    referrer: '',
    errorMsg: undefined
  })
  const { initSecuritySetting } = services
  
  useEffect(() => {
    initSecuritySetting({
      params: {},
      resolve: response => {
        setSecurityInitData({
          initComplete: true,
          phoneInfo: {
            number: response.phoneInfo?.number,
            isPrimary: response.phoneInfo?.primary
          },
          emailInfo: {
            address: response.emailInfo?.address,
            isPrimary: response.emailInfo?.primary,
            isVerified: response.emailInfo?.verified
          },
          locale: response.locale,
          nextTimePhone: response.nextTimePhone,
          nextTimeEmail: response.nextTimeEmail,
          stateChecker: response.stateChecker,
          referrer: response.referrer,
        })
      },
      reject: () => {
        setSecurityInitData({
          initComplete: true,
          errorMsg: i18n('passport.error.server.default')
        })
      },
    })
  }, [])

  return (
    securityInitData.initComplete && <SecuritySetting 
      {...rest}
      services={services}
      kcErrorMessage={securityInitData.errorMsg}
      configureTrack={configureTrack}
      phoneInfo={securityInitData.phoneInfo}
      emailInfo={securityInitData.emailInfo}
      locale={securityInitData.locale}
      nextTimePhone={securityInitData.nextTimePhone}
      nextTimeEmail={securityInitData.nextTimeEmail}
      stateChecker={securityInitData.stateChecker}
      referrer={securityInitData.referrer}
    />
  )
}

const SecuritySettingWidget = injectWidget({
  widget: SecuritySettingBuild,
  serviceConfig: securitySettingServiceConfig,
})

export default SecuritySettingWidget